import { useUserStore } from "@/stores/user";
import { computed } from "vue";

const getNestedTranslation = (obj: any, path: string): any => {
  return path.split(".").reduce((acc, part) => acc?.[part], obj);
};

export const useTranslate = () => {
  const userStore = useUserStore();

  // This returns a computed ref that updates automatically when translations change
  const t = (key: string) => {
    return computed(() => {
      const translations = { ...userStore.getAdminTranslations };
      const currentLanguage = userStore.getCurrentLanguage;
      const nested = getNestedTranslation(translations, key);

      return nested?.[currentLanguage] || key;
    });
  };

  return { t };
};
